import { SelectOptionStatus } from "@smartsuite/automation-engine-api";

/** Maps API / JSON status values to {@link SelectOptionStatus}. */
export const normalizeSelectOptionStatus = (
  status: unknown,
): SelectOptionStatus | undefined => {
  if (status === undefined || status === null) {
    return undefined;
  }

  if (status === SelectOptionStatus.DISABLED) {
    return SelectOptionStatus.DISABLED;
  }
  if (status === SelectOptionStatus.ENABLED) {
    return SelectOptionStatus.ENABLED;
  }
  return undefined;
};

export const isSelectOptionDisabled = (status: unknown): boolean =>
  normalizeSelectOptionStatus(status) === SelectOptionStatus.DISABLED;
